var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("button", { on: { click: _vm.onClick } }, [
    _c("div", { staticClass: "atbName" }, [_vm._v(_vm._s(_vm.displayName))]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showingMessage,
            expression: "showingMessage"
          }
        ],
        staticClass: "messageTooltip"
      },
      [_vm._v(_vm._s(_vm.messageText))]
    ),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.inputValue,
          expression: "inputValue"
        }
      ],
      staticClass: "offScreen",
      attrs: { id: "copyInput", tabindex: "-1", "aria-hidden": "true" },
      domProps: { value: _vm.inputValue },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.inputValue = $event.target.value
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }